





































import { Vue, Component, Prop } from "@/shared/vuepack";
import HsaBankOnboardingFooter from "@/employee/components/shared/HsaBankOnboardingFooter.vue";
import TransferFunds from "@/employee/components/onboarding/balance-transfer/TransferFunds.vue";
import TrusteeToTrusteeTransferDetails from "@/employee/components/onboarding/balance-transfer/TrusteeToTrusteeTransferDetails.vue";
import TrusteeToTrusteeTransferFormDownload from "@/employee/components/onboarding/balance-transfer/TrusteeToTrusteeTransferFormDownload.vue";
import TrusteeToTrusteeTransferFinish from "@/employee/components/onboarding/balance-transfer/TrusteeToTrusteeTransferFinish.vue";
import RolloverDetails from "@/employee/components/onboarding/balance-transfer/RolloverDetails.vue";
import RolloverFormDownload from "@/employee/components/onboarding/balance-transfer/RolloverFormDownload.vue";
import RolloverFinish from "@/employee/components/onboarding/balance-transfer/RolloverFinish.vue";
import { BalanceTransferStep, BalanceTransferStepKey, balanceTransferStepKeyRing } from "@/shared/types";
import { useBalanceTransferStore } from "@/employee/store/balanceTransfer";
import { useUserBankAccountStore } from "@/shared/store/userBankAccount";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import { Home } from "@/employee/route-names";

@Component({
  components: {
    HsaBankOnboardingFooter,
    TransferFunds,
    TrusteeToTrusteeTransferDetails,
    TrusteeToTrusteeTransferFormDownload,
    TrusteeToTrusteeTransferFinish,
    RolloverDetails,
    RolloverFormDownload,
    RolloverFinish
  }
})
export default class BalanceTransfer extends Vue {
  balanceTransferStore = useBalanceTransferStore();
  userBankAccountStore = useUserBankAccountStore();
  hsabAccountsStore = useHsabAccountsStore();

  @Prop()
  stepKey: BalanceTransferStepKey;

  get currentStep () {
    if (!this.stepKey) {
      return BalanceTransferStep.TransferFunds;
    }

    return balanceTransferStepKeyRing[this.stepKey];
  }

  get title () {
    switch (this.currentStep) {
      case BalanceTransferStep.TransferFunds:
        return "Transfer funds";
      case BalanceTransferStep.TrusteeToTrusteeTransferDetails:
      case BalanceTransferStep.TrusteeToTrusteeTransferFormDownload:
      case BalanceTransferStep.TrusteeToTrusteeTransferFinish:
        return "Trustee-to-trustee transfer";
      case BalanceTransferStep.RolloverTransferDetails:
      case BalanceTransferStep.RolloverTransferFormDownload:
      case BalanceTransferStep.RolloverTransferFinish:
        return "Rollover";
      default:
        return "";
    }
  }

  get displayTitle () {
    if (this.isOnboarding) {
      return !!this.title;
    }

    return this.currentStep !== BalanceTransferStep.TransferFunds;
  }

  get isOnboarding () {
    return this.balanceTransferStore.isOnboarding;
  }

  get isTransferFundsStep () {
    return this.currentStep === BalanceTransferStep.TransferFunds;
  }

  get isTrusteeToTrusteeTransferDetails () {
    return this.currentStep === BalanceTransferStep.TrusteeToTrusteeTransferDetails;
  }

  get isTrusteeToTrusteeTransferFormDownload () {
    return this.currentStep === BalanceTransferStep.TrusteeToTrusteeTransferFormDownload;
  }

  get isTrusteeToTrusteeTransferFinish () {
    return this.currentStep === BalanceTransferStep.TrusteeToTrusteeTransferFinish;
  }

  get isRolloverDetails () {
    return this.currentStep === BalanceTransferStep.RolloverTransferDetails;
  }

  get isRolloverFormDownload () {
    return this.currentStep === BalanceTransferStep.RolloverTransferFormDownload;
  }

  get isRolloverFinish () {
    return this.currentStep === BalanceTransferStep.RolloverTransferFinish;
  }

  get isHsaReady () {
    return this.hsabAccountsStore.allHsabAccounts.length > 0;
  }

  created () {
    if (!this.hsabAccountsStore.canDeposit) {
      this.$router.push({ name: Home });
    } else if (!this.isOnboarding && this.isHsaReady) {
      this.userBankAccountStore.loadBankAccountState();
    }
  }

  beforeDestroy () {
    this.balanceTransferStore.clearState();
  }
}
